@if (previews().length > 0) {
  <div class="mt-4">
    <div class="relative">
      <div class="flex gap-3 overflow-x-auto pb-2 snap-x snap-mandatory scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100">
        @for (preview of previews(); track preview.name; let i = $index) {
          <div
            class="cursor-move transition-all duration-200 ease-out {{ getItemClasses(i) }}"
            draggable="true"
            (dragstart)="onDragStart($event, i)"
            (dragend)="onDragEnd()"
            (dragover)="onDragOver($event, i)"
            (dragleave)="onDragLeave()"
            (drop)="onDrop($event)"
          >
            <app-news-image
              [preview]="preview"
              (remove)="onRemove(i)"
            />
          </div>
        }
      </div>
    </div>
  </div>
}
